module.exports = __webpack_public_path__ + "static/img/Icon-Prestations.e15631e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon-Prestations.svg
// module id = TmjL
// module chunks = 1